const NAMESPACE = 'openclassrooms/funnel/';

export default {
  GO_TO_NEXT_SCREEN: `${NAMESPACE}GO_TO_NEXT_SCREEN`,
  RESET_NEXT_SCREEN_FLAG: `${NAMESPACE}RESET_NEXT_SCREEN_FLAG`,
};
